import { message } from 'antd';

export const notifySuccess = (notification?: any) => {
	message.success(notification || 'Saved Successfully!', 5);
};
export const notifyError = (notification?: any) => {
	message.error(notification || 'Saved Successfully!', 5);
};
